import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import { X } from 'lucide-react'

export default function Modal({ isOpen, onClose, title, children }) {
  return (
    <Transition grow show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-[200]" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/90 backdrop-blur-md" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="relative neu-panel w-full max-w-2xl transform overflow-hidden text-left align-middle shadow-glossy transition-all flex flex-col max-h-[85vh]">
                <div className="absolute inset-0 bg-gradient-to-br from-white/[0.05] to-transparent pointer-events-none z-0"></div>
                
                <div className="relative z-10 flex items-center justify-between px-8 py-6 border-b border-white/10 bg-hs-surface/50">
                  <Dialog.Title as="h2" className="text-xl font-display font-bold text-white tracking-tighter text-gloss">
                    {title}
                  </Dialog.Title>
                  <button
                    onClick={onClose}
                    className="w-10 h-10 neu-button flex items-center justify-center text-hs-text hover:text-white transition-all active:scale-95"
                    aria-label="Close modal"
                  >
                    <X size={20} />
                  </button>
                </div>

                <div className="relative z-10 p-8 overflow-y-auto custom-scrollbar">
                  <div className="text-hs-text leading-relaxed">
                    {children}
                  </div>
                </div>
                
                <div className="relative z-10 p-4 border-t border-white/10 bg-hs-surface/30 flex justify-end">
                  <button 
                    onClick={onClose}
                    className="px-6 py-2 neu-button text-[10px] font-mono font-bold text-hs-text hover:text-white uppercase tracking-widest"
                  >
                    Close
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}
